import React, { useState } from 'react';
import { FileText, Briefcase, Database } from 'lucide-react';
import { useTabPersistence } from '../../hooks/usePersistence';
import CVGenerationTab from './CVGeneration/CVGenerationTab';
import ProjectInvolvementTab from './CVGeneration/ProjectInvolvementTab';
import DataEntryTab from './CVGeneration/DataEntryTab';

// Valid tab IDs for URL sync
const VALID_TABS = [
  'cv-generation',
  'project-involvement',
  'data-entry',
];

const CVGeneration = () => {
  // Use URL-synced tab persistence
  const [activeTab, setActiveTab] = useTabPersistence('cv-generation', 'cv-generation', VALID_TABS);

  const tabs = [
    { 
      id: 'cv-generation', 
      name: 'CV Generation', 
      icon: FileText, 
      description: 'Generate employee CVs for tender submissions' 
    },
    { 
      id: 'project-involvement', 
      name: 'Project Involvement', 
      icon: Briefcase, 
      description: 'Manage employee project involvement data' 
    },
    { 
      id: 'data-entry', 
      name: 'Data Entry', 
      icon: Database, 
      description: 'Quick entry of CV data (Education, Work Experience, Certificates)' 
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'cv-generation':
        return <CVGenerationTab />;
      case 'project-involvement':
        return <ProjectInvolvementTab />;
      case 'data-entry':
        return <DataEntryTab />;
      default:
        return <CVGenerationTab />;
    }
  };

  return (
    <div className="space-y-6 md:space-y-8 bg-gray-50 min-h-screen">
      {/* Page Header */}
      <div>
        <div className="flex items-center gap-3 mb-1 min-w-0">
          <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
            <Briefcase className="w-4 h-4 sm:w-5 sm:h-5 text-red-600" />
          </div>
          <h1 className="text-lg sm:text-2xl font-bold text-gray-900 min-w-0 truncate">CV Generation</h1>
        </div>
        <p className="text-xs sm:text-sm text-gray-500 ml-11 sm:ml-12">Generate employee CVs for tender submissions and manage project involvement data</p>
      </div>

      {/* Tabs - Following Design System */}
      <div className="flex items-center gap-2 overflow-x-auto md:flex-wrap md:overflow-x-visible scrollbar-hide scroll-smooth mb-4 md:mb-6">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tab-btn-admin ${isActive ? 'active' : ''}`}
              title={tab.description}
            >
              <Icon className="w-4 h-4" />
              {tab.name}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default CVGeneration;

